export enum AipEventTypes {
  policyProducerUpdate = 'policyProducerUpdate',
  lrpPremiumUpdate = 'lrpPremiumUpdate',
  lgmPremiumUpdate = 'lgmPremiumUpdate',
  submitAipLrpCoverage = 'submitAipLrpCoverage',
  submitAipLgmCoverage = 'submitAipLgmCoverage',
  syncAip = 'syncAip',
}
